import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isSlimModeSubject = new BehaviorSubject<boolean>(false);
  private isManualToggleSubject = new BehaviorSubject<boolean>(false);
  private screenThreshold: number = 1200;

  public isSlimMode$: Observable<boolean> = this.isSlimModeSubject.asObservable();
  public isManualToggle$: Observable<boolean> = this.isManualToggleSubject.asObservable();

  constructor() {
    this.checkScreenSize(window.innerWidth);
  }

  get isSlimMode(): boolean {
    return this.isSlimModeSubject.value;
  }

  get isManualToggle(): boolean {
    return this.isManualToggleSubject.value;
  }

  checkScreenSize(width: number): void {
    const newSlimMode = width < this.screenThreshold;
    if (this.isManualToggleSubject.value) {
      const currentSlimMode = this.isSlimModeSubject.value;
      if (newSlimMode === currentSlimMode) {
        this.isManualToggleSubject.next(false);
      }
    }

    if (!this.isManualToggleSubject.value) {
      this.isSlimModeSubject.next(newSlimMode);
    }
  }

  toggleSlimMode(): void {
    this.isManualToggleSubject.next(true);
    const newSlimMode = !this.isSlimModeSubject.value;
    this.isSlimModeSubject.next(newSlimMode);
  }

  resetManualToggle(): void {
    this.isManualToggleSubject.next(false);
  }

  setSlimMode(isSlim: boolean): void {
    this.isSlimModeSubject.next(isSlim);
  }

  forceSlimMode(): void {
    this.isManualToggleSubject.next(true);
    this.isSlimModeSubject.next(true);
  }
}
